/** Imagen de perfil, con la uri y la url que envia Drupal. */
export interface UserPicture {
    uri?: string;
    url?: string;
}

/** Usuario tal cual lo envia el backend. */
export interface UserRawData {
    uid: string | number;
    name: string;
    picture: UserPicture;
}

/**
 * Object to store user data.
 */
class UserData {
    // Drupal uid and name.
    uid: string | number;
    name: string;
    // Object with Drupal uri and url
    picture: UserPicture;

    constructor(uid: string | number, name: string, picture: UserPicture) {
      this.uid = uid;
      this.name = name;
      this.picture = picture;
    }
    
    /**
     * Build object from raw data.
     */
    static fromRawData(data: UserRawData): UserData {
      return new UserData(data.uid, data.name, data.picture);   
    }   
    
    /**
     * Get the user id stored on local storage.
     */
    getUserId(): string | number {
      return this.uid;
    }

    /**
     * Get the user name stored on local storage.
     */
    getName(): string {
      return this.name;
    }

    /**
     * Get the user picture from user data
     */
    getPictureUrl(): string | undefined {
      return this.picture.url;
    }
    
    
}

export default UserData;
